<template>
  <div class="search-content">
    <div class="search-wrap">
      <input type="text" maxlength="250" v-model="inputValue" @click.stop="inputFocus" @focus="inputFocus" :placeholder="placeholderText" @keyup.enter="save" :class="{hideInputBorder: ulVisible, 'search-input': true, focus: this.ulVisible}" ref="input" />
      <span class="clear-btn" @click="clear" v-if="this.inputValue.length > 0"></span>
      <span class="search-btn" @click="save"><span></span></span>
      <div class="more_ul_box" v-show="ulVisible" ref="moreUl">
        <div class="more_ul_box_scroll scrollbar">
          <ul class="search-more">
            <li class="company" v-for="item in realList" :key="item.id" @click.self="clickItem(item.content)">
              <span class="name" @click.self="clickItem(item.content)"> {{ item.content }}</span>
              <span class="li-close" @click.self="delHistory(item.id)"></span>
            </li>
            <li class="del-history">
              <span @click="delHistory('all')">{{ $t('3ad3cfa11b') }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getList, getCollect, getHistoryList, clearHistory, saveHistory} from '@/api/apiList'
import {list, historyList} from '@/assets/mockData.js'
export default {
  name: 'search',
  data() {
    return {
      inputValue: '',
      ulVisible: false,
      browse: [],
      historyList: [],
      // 热搜换一批
      placeholderText: $t('cd11be8c92'),
      hoverInput: false,
      flag: null
    }
  },
  computed: {
    realList() {
      return this.historyList.slice(-3)
    },
    inputBorder() {
      return this.ulVisible ? 'inherit' : '1px solid #ececf7'
    }
  },
  props: {
    data: {
      type: String,
      default: ''
    },
    collect: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data(newValue, oldValue) {
      this.inputValue = newValue
    }
  },
  methods: {
    // todo 搜索
    searchClick(val) {
      if (this.collect) {
        this.$Bus.$emit('collectSearch', val)
      } else {
        this.$Bus.$emit('search', val)
      }
      this.ulVisible = false
      this.flag = false
      // 父元素搜索
    },

    inputBlur() {
      this.ulVisible = false
    },
    inputFocus() {
      if (this.realList.length > 0) {
        this.ulVisible = true
      }
    },
    async delHistory(id) {
      let res = await clearHistory({
        id
      }).catch(error => {
        this.empty = 'error'
        this.emptyText = $t('866b795eae')
      })
      if (res && res.code === 1) {
        let {data} = res
        if (id != 'all') {
          let index = this.historyList.findIndex(d => d.id == id)
          this.historyList.splice(index, 1)
          console.log(this.historyList, index, id)
          if (this.historyList.length == 0) {
            this.historyList = []
            this.ulVisible = false
          }
        } else {
          this.historyList = []
          this.ulVisible = false
        }
      } else {
      }
    },
    clickItem(content) {
      if (this.flag) {
        return
      } else {
        this.flag = true
        this.inputValue = content
        this.save()
      }
    },
    async save() {
      this.$refs.input.blur()
      let {inputValue} = this
      if (inputValue) {
        let res = await saveHistory({
          content: inputValue
        }).catch(error => {
          this.empty = 'error'
          this.emptyText = $t('866b795eae')
        })
        if (res && res.code === 1) {
          this.getHistoryData()
        }
      }
      this.searchClick(inputValue)
    },
    async getHistoryData() {
      let res = await getHistoryList().catch(error => {
        this.empty = 'error'
        this.emptyText = $t('866b795eae')
      })
      if (res && res.code === 1) {
        let {data} = res
        if (data.length > 0) {
          this.historyList = data
        } else {
          this.empty = 'data'
          this.emptyText = $t('d12f75264c')
        }
      } else {
        this.empty = 'error'
        this.emptyText = $t('866b795eae')
      }
    },
    clear() {
      this.inputValue = ''
      this.searchClick('')
      // setTimeout(() => {
      //   this.$refs.input.focus()
      // })
    }
  },
  created() {
    this.getHistoryData()
    document.addEventListener('click', e => {
      if (this.$refs.moreUl) {
        let isSelf = this.$refs.moreUl.contains(e.target)
        if (!isSelf) {
          this.ulVisible = false
        }
      }
    })
    // this.getAuthority();
  },

  mounted() {}
}
</script>
<style lang="less" scoped>
@width: 1200px;
@grey: #c8e2fc;
.search-content {
  position: relative;
  .search-wrap {
    display: flex;
    width: 520px;
    margin: 0 auto;
    height: 36px;
    font-size: 0;
    border-radius: 50%;
    .hideInputBorder {
      border: 1px solid #1b63d9 !important;
      border-bottom: 1px solid #ececf7 !important;
    }
    .search-input {
      width: 464px;
      height: 100%;
      padding: 0 15px;
      font-size: 16px;
      color: #323232;
      background: #edf2f5;
      border: 1px solid #ececf7;
      border-radius: 26px 0 0 26px;
      caret-color: #1b63d9;
      text-indent: 10px;
      &::-webkit-input-placeholder {
        color: #c0c4cc;
      }
      &:focus {
        border: 1px solid #3c79de;
        background: #fff;
      }
      &.focus {
        border-radius: 26px 0 0 0px;
      }
      &:hover {
        border: 1px solid #3c79de !important;
        background: #fff;
      }
    }
    .clear-btn {
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/close.svg') no-repeat 100% 100%;
      display: inline-block;
      position: absolute;
      left: 428px;
      top: 10px;
      cursor: pointer;
    }
    .search-btn {
      display: flex;
      align-items: center;
      width: 64px;
      height: 100%;
      background-color: #1b63d9;
      font-size: 16px;
      color: @grey;
      cursor: pointer;
      vertical-align: top;
      border-radius: 0 26px 26px 0;
      span {
        margin: 0 auto;
        width: 20px;
        height: 20px;
        background: url(~@/assets/images/search24.svg) no-repeat center;
      }
    }
    .more_ul_box {
      font-size: 14px;
      position: absolute;
      background: #fff;
      width: 457px;
      z-index: 999;
      top: 36px;
      left: 0px;
      color: #666;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      border-bottom: 1px solid #1b63d9;
      border-left: 1px solid #1b63d9;
      border-right: 1px solid #1b63d9;
      border-radius: 0px 0 26px 26px;
      box-shadow: 0 4px 12px 0 rgba(10, 39, 86, 0.15);
      .more_ul_box_scroll {
        max-height: 600px;
        overflow: auto;
        margin-bottom: 15px;
      }
      ul {
        &.search-more {
          margin-top: 12px;
          li {
            padding: 0 16px;
            height: 36px;
            line-height: 36px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
            color: #fff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .name {
              font-family: Microsoft YaHei;
              font-size: 14px;
              color: #474762;
              line-height: 22px;
              font-weight: 400;
            }
            .li-close {
              width: 20px;
              height: 20px;
              background: url('~@/assets/images/close.svg') no-repeat 100% 100%;
              display: inline-block;
            }
            &.del-history {
              height: 36px;
              font-size: 12px;
              display: flex;
              flex-direction: row-reverse;
              align-items: center;
              cursor: default;
              text-align: right;
              span {
                cursor: pointer;
                color: #1b63d9;
                &:hover {
                  color: #3b82f4;
                }
              }
            }
            &:hover {
              background: #f7f7fc;
            }
          }
          .on {
            background: #e2eeff;
          }
        }
      }
    }
  }
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #7d7d94 !important;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #7d7d94 !important;
}
input:-ms-input-placeholder {
  color: #7d7d94 !important;
}

input::-webkit-input-placeholder {
  color: #7d7d94 !important;
}
</style>
